import React, { createContext, useContext } from 'react';

import { ISwitchMenuOptions } from '../../types';

const SwitchMenuContext = createContext<Required<ISwitchMenuOptions> | null>(null);

export const useSwitchMenuContext = () => {
  const context = useContext(SwitchMenuContext);
  if (!context) {
    throw new Error('useSwitchMenuContext must be used within a SwitchMenuProvider');
  }
  return context;
};

interface ISwitchMenuOptionsDataProviderProps {
  value: ISwitchMenuOptions;
  children: React.ReactNode;
}

export const SwitchMenuProvider: React.FC<ISwitchMenuOptionsDataProviderProps> = ({ value, children }) => {
  return <SwitchMenuContext.Provider value={{ ...value }}>{children}</SwitchMenuContext.Provider>;
};
